import option from '../js/option'

export default [
  {
    path: option.packagePath,
    component: () => import('../../views/Package'),
    redirect: '/ssp',
    children: [
      {
        path: '/ssp',
        name: option.header.nameText.ssp,
        component: () => import('../../components/ssp')
      },
      {
        path: '/dsp',
        name: option.header.nameText.dsp,
        component: () => import('../../components/dsp')
      },
      {
        path: '/ads',
        name: option.header.nameText.ads,
        component: () => import('../../components/ads')
      },
      {
        path: '/more',
        name: option.header.nameText.more,
        component: () => import('../../components/more')
      }
    ]
  },
  {
    path: '*',
    redirect: '/ssp',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/assets/js/router.js